import React from "react";
import Navbar from "./Navbar";
import bga from "../assets/aboutbg.webp";
import Footer from "./Footer";
import patient from "../assets/patient.webp";
import { Link, NavLink } from "react-router-dom";
import ScrollToTop from '../Components/Scroll.js'

const Services = () => {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      {/* Hero Section */}
      <div className="relative w-full h-[300px]">
        {/* Background Image */}
        <img src={bga} alt="About Us" className="w-full h-full object-cover" />

        {/* Centered Content */}
        <div className="absolute inset-0 flex flex-col items-center justify-center space-y-4 md:space-y-6 px-4">
          {/* Heading */}
          <h1 className="text-white text-4xl md:text-6xl font-bold drop-shadow-md text-center">
            Emergency Room Medical Billing Services
          </h1>
          <p className="text-white font-semibold text-center max-w-[90%]">
            Axion is a Birmingham-based emergency room billing service. We
            have years of experience dealing with and maintaining the RCM
            process and streamlining it. Our error-free coding and billing
            solutions ensure appropriate management at every step of the way.
          </p>

          {/* Contact Us Button */}
          <NavLink
            to="/Contact"
            className="border-2 border-gray-100 rounded-lg text-white cursor-pointer font-sans font-semibold text-base leading-normal px-8 py-3 outline-none transition-all duration-300 ease-[cubic-bezier(0.23,1,0.32,1)] hover:shadow-lg hover:-translate-y-1 active:shadow-none active:translate-y-0 disabled:pointer-events-none"
          >
            Book Your Appointment Today
          </NavLink>
        </div>
      </div>

      {/* Content Section */}
      <div className="flex flex-col md:flex-row gap-8 px-4 py-8">
        <div className="flex-1">
          <h1 className="font-sans font-bold text-5xl bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent mb-4">
            Emergency Room <span className="text-black font-bold font-sans">Medical Billing Services</span>
          </h1>

          <p className="font-sans text-lg text-black break-words mb-4">
            Axion offers Accurate emergency room medical billing services all
            over the USA to streamline your revenue cycle management. We are
            chosen by the large healthcare system to serve with:
          </p>
          <ul className="list-disc list-inside text-left text-lg text-gray-700 mb-6">
            <li className="font-semibold font-sans text-black">Hospital emergency room</li>
            <li className="font-semibold font-sans text-black">Freestanding emergency rooms</li>
          </ul>
          <p className="font-sans text-lg text-black break-words mb-4">
            We understand the importance of accurate billing for widely popular
            freestanding emergency rooms that doesn’t end in discharges not
            fully billed. Our expert ER billing specialist at MedHeave ensures
            you receive an appropriate amount from the services rendered to the
            patient. Lost revenue is your practice’s killer. Hire billing
            professionals to ensure your practice stays running and receives
            compensation from payers.
          </p>
        </div>
        <div className="flex-1">
          <img
            src={patient}
            alt="Emergency Room"
            className="w-full h-auto rounded-lg shadow-lg object-cover"
          />
        </div>
      </div>

      {/* Footer Section */}
      <Footer />
    </>
  );
};

export default Services;
